"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var Button_1 = __importDefault(require("@mui/material/Button"));
var patch_base_button_components_1 = __importDefault(require("./patch-base-button-components"));
exports.Button = (0, patch_base_button_components_1.default)(Button_1.default);
//# sourceMappingURL=button.js.map